<div class="video-container">
  <iframe [src]="parsedURL | domSafe" class="video-iframe" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen #videoFrame></iframe>
</div>